import { Component, OnInit } from '@angular/core';
import { RefClient } from 'src/app/services/api-client';
import { LoginComponent } from 'src/app/portal/login/login.component';
import { PermissionCodes } from 'src/app/services/classes';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';


export interface NotificationRequest {
  notificationByType: {
    requestType: string,
    count: number,
    routeTo: string,
  }[],
  totalNotification: number
}
@Component({
  selector: 'app-layout-header',
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.css'],
  providers: [LoginComponent]
})
export class LayoutHeaderComponent implements OnInit {

  constructor(private refclient: RefClient, private azureAD: LoginComponent, private router: Router) { }
  title?: string;
  userName?: string;
  userEmail?: string;
  Notification?: NotificationRequest;
  showNotification?: boolean = true;
  isCommercialization?: boolean = true;

  ngOnInit(): void {
    var id = localStorage.getItem("prspUserId")!;
    var userName = localStorage.getItem("prspUserName")!;
    var userEmail = localStorage.getItem("prspUserEmail")!;

    this.isCommercialization = environment.isCommercialization;
    this.userName = userName;
    this.userEmail = userEmail;

    // TODO: To get title from database table or self-defined here.
    if (this.isCommercialization) this.title = "Predictive Analytic Freespan (PrAnSpan)";
    else this.title = "PETRONAS Predictive Analytic Freespan (PrAnSpan)";
    
    // this.refclient.getApplicationConfig().subscribe((result) => {
    //   var title = result.title;
    //   this.title = title;
    // },
    //   error => {
    //     console.log(error);
    // })

    this.refclient.getAllMPointsPendingImportRequest().subscribe((result) => {
      if (result) {
        const metoceanCount = Number(result?.filter(entry => entry?.requestType === "Metocean Points").length ?? 0);
        const inspectionCount = Number(result?.filter(entry => entry?.requestType === "Inspection Data").length ?? 0);
        const vectorizedCount = Number(result?.filter(entry => entry?.requestType === "Vectorized Data").length ?? 0);
        const totalCount = metoceanCount + inspectionCount + vectorizedCount;

        const notificationList: NotificationRequest = {
          notificationByType: [
            {
              requestType: 'New Inspection Data Request(s)',
              count: inspectionCount,
              routeTo: '/pendingrequest',
            },
            {
              requestType: 'New Metocean Points Request(s)',
              count: metoceanCount,
              routeTo: '/pendingrequest',
            },
            {
              requestType: 'New Vectorized Data Request(s)',
              count: vectorizedCount,
              routeTo: '/pendingrequest'
            },
          ],
          totalNotification: totalCount,
        };

        this.Notification = notificationList;
        this.showNotification = true;
      };
  },
    error => {
      console.log(error);
    })
  }

  redirectToNotification(route: string) {
    this.router.navigate([route]);
  }

  signOut(){
    this.azureAD.AzureADLogOut();
  }
}
